<template>
  <v-container grid-list-lg fluid>

    <v-layout align-center justify-start class="header">
      <v-flex>
        <h2>Sales Funnel</h2>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs4>
        <v-progress-linear v-if="!owners.length" indeterminate class="loader"></v-progress-linear>
        <new-funnel-form v-if="owners.length" @newChart="createNewChart"></new-funnel-form>
      </v-flex>
      <v-flex xs4 v-if="loadingChart">
        <v-progress-linear indeterminate class="loader"></v-progress-linear>
      </v-flex>
      <v-flex xs4 v-for="data in chartData" :key="data.id">
        <funnel-chart :data="data"></funnel-chart>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import NewFunnelForm from './NewFunnelForm.vue';
import FunnelChart from './FunnelChart.vue';

export default {
  name: 'SalesFunnel',

  components: {
    NewFunnelForm,
    FunnelChart
  },

  data() {
    return {
      loadingChart: false
    };
  },

  computed: {
    ...mapState('leadOwners', ['owners']),
    ...mapState('salesFunnel', ['chartData'])
  },

  methods: {
    ...mapActions('leadOwners', ['getData']),
    ...mapActions('salesFunnel', ['getChart']),

    createNewChart(chartDataParams) {
      this.loadingChart = true;
      this.getChart(chartDataParams)
        .then(() => {
          this.loadingChart = false;
        })
        .catch(() => {
          this.loadingChart = false;
        });
    },

    getLeadOwners() {
      this.getData();
    }
  },

  mounted() {
    this.getLeadOwners();
  }
};
</script>

<style lang="scss" scoped>
  .header h2 {
    margin: 0px 18px;
  }

  .loader {
    margin-top: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/reports/leads/SalesFunnel.vue